import { initialMapAddress } from 'src/types/common/address';
import { Company } from '../../../types/common/company';

export const initialCompanyState: Company = {
  id: 0,
  companyName: null,
  dba: null,
  dotNumber: null,
  mcNumber: null,
  garagingAddress: initialMapAddress,
  mailingAddress: initialMapAddress,
  status: 'INACTIVE',
  twoYearsPreviousAuthority: false,
  yearsInBusiness: 0,
  monthsInBusiness: 0,
  dateBusinessStarted: null,
  bizPhone: null,
  bizEmail: null,
  website: null,
  fleetSize: 0,
  totalPowerUnits: 0,
  cdlEmployedDrivers: 0,
  interStateDriversTotal: 0,
  intraStateDriversTotal: 0,
  cdlDriverCompliancePercentage: 0.0, // Ensure decimal support
  eldCompliant: false,
  currentAutoExpDate: null,
  currentAutoLimit: { amount: 0.0, currency: 0 },
  currentPDExpDate: null,
  currentPDDed: { amount: 0.0, currency: 0 },
  currentMTCExpDate: null,
  currentMTCLimit: { amount: 0.0, currency: 0 },
  currentGLExpDate: null,
  currentGLLimit: { amount: 0.0, currency: 0 },
  currentWCExpDate: null,
  currentWCLimit: { amount: 0.0, currency: 0 },
  currentWCDed: { amount: 0.0, currency: 0 },
  currentOAExpDate: null,
  ein: null,
  activeAuthority: false,
  entityType: 'C_CORPORATION', // Default value
  users: [],
  vehicles: [],
  drivers: [],
  COIs: [],
  commodities: [],
  safetyScores: [],
  policies: [],
  cancellations: [],
  quotes: [],
  flowStep: 'SALES_FLOW',
  leadScore: 'NO_TOUCH',
};
